<div class="block">
  <div class="block-header block-header-default">
    <h3 class="block-title">Update Images</h3>
  </div>
  <div class="block-content block-content-full">

    <div class="row">

      <div class="col-md-12">

        <div class="table-responsive">
          <table class="table table-sm">
            <thead>
            <tr>
              <th>Image</th>
              <th>Identifier</th>
              <th>Filetype</th>
              <th>Resolution</th>
              <th>Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let image of imageList">
              <td class="text-left">
                <img *ngIf="image.fileName != null" src="{{image.fileName}}" alt="{{image.identifier}}" width="100px">
              </td>
              <td>{{ image.identifier }}</td>
              <td>{{ image.fileType }}</td>
              <td>{{ image.resolution }}</td>
              <td>
                <input
                  type="file"
                  id="{{image.identifier}}"
                  accept=".{{image.fileType}}"
                  (change)="onFileSelected($event, image.identifier)"
                />
              </td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
  <div class="block-content block-content-full bg-body-light">
    <button class="btn btn-success" (click)="uploadFiles()">Upload</button>
  </div>
</div>
